export const currencyFormatters = {
  eur: {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 1,
  },
  usd: {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 1,
  },
};
